import { ENV } from "@/config/env";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

export const SITE_NAME = "Subrahmanya Rudraksha";
export const SITE_SHORT_NAME = "Subrahmanya Rudraksha";
export const SITE_TAGLINE =
  "Authentic Rudraksha beads, malas, and spiritual guidance from the sacred Himalayas.";

export const SITE_URL = trimTrailingSlash(
  ENV.SITE_URL || "https://www.subrahmanyarudraksha.com",
);

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
export const DEFAULT_LOGO = `${SITE_URL}/Logo.png`;

export const CONTACT_INFO = {
  phone: ["+91 7017165652", "+91 8057604337"],
  email: "contact@subrahmanyarudraksha.com",
  address: "Himalayan Foothills, Nepal",
  region: "India",
};

export const SOCIAL_LINKS = [
  "https://www.instagram.com/",
  "https://www.youtube.com/",
  "https://www.facebook.com/",
];

export const BRAND_KEYWORDS = [
  "Rudraksha",
  "mala",
  "spiritual guidance",
  "authentic rudraksha beads",
  "lab certified rudraksha",
  "online rudraksha store",
];
